import { Component, OnInit } from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router
} from '@angular/router';
import { firstValueFrom, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'app-page-nav-loader',
  templateUrl: './page-nav-loader.component.html',
  styleUrls: ['./page-nav-loader.component.scss']
})
export class PageNavLoaderComponent implements OnInit {

  public isLoading$: Observable<boolean>;
  public translations: any;
  public waitMessage: any;

  constructor(private router: Router,
    private translateService: TranslateService) {}

  ngOnInit(): void {
    this.getTranslations();
    this.isLoading$ = this.router.events.pipe(
      filter(
        event =>
          event instanceof NavigationStart ||
          event instanceof NavigationEnd ||
          event instanceof NavigationCancel ||
          event instanceof NavigationError
      ),
      map(event => !!(event instanceof NavigationStart))
    );
  }

  public async getTranslations() {
    const translations = await firstValueFrom(this.translateService.get([
      'Common.WaitMessage']));

    this.translations = translations;
    this.waitMessage = this.translations['Common.WaitMessage'];
  }

}
